export default __webpack_public_path__ + "static/media/cod.50b39285.svg";